import { composeIO } from 'react-compose-io'
import { itemTipoLancamentoIO } from './ItemTipoLancamento.IO'
import { ItemTipoLancamentoView } from './ItemTipoLancamento.View'

export const ItemTipoLancamento = composeIO(ItemTipoLancamentoView, itemTipoLancamentoIO)
